import { useTableTemplateStore } from "../../store/tableTemplateStore";
import ColumnTreeNode from "./ColumnTreeNode";
import { findColumnById } from "./tableBuilderUtils/columnUtils";

export default function ColumnTree() {
  const schema = useTableTemplateStore((s) => s.editorSchema);
  const selectedColumnId = useTableTemplateStore((s) => s.selectedColumnId);
  const addRootColumn = useTableTemplateStore((s) => s.addRootColumn);
  const addChildColumn = useTableTemplateStore((s) => s.addChildColumn);
  const updateColumn = useTableTemplateStore((s) => s.updateColumn);
  const lockState = useTableTemplateStore((s) => s.lockState);

  if (!schema) return null;

  const selectedColumn = selectedColumnId
    ? findColumnById(schema.columns, selectedColumnId)
    : null;
  const isLocked = !!lockState?.isLocked;

  const handleAddChild = () => {
    if (!selectedColumnId || isLocked) return;
    addChildColumn(selectedColumnId);
  };

  const handleEqualDistribution = () => {
    if (isLocked) return;

    const targets =
      selectedColumn?.columns && selectedColumn.columns.length > 0
        ? selectedColumn.columns
        : schema.columns;

    if (targets.length === 0) return;

    const base = Math.floor(100 / targets.length);
    const remainder = 100 - base * targets.length;

    targets.forEach((col, index) => {
      const width = index === targets.length - 1 ? base + remainder : base;
      updateColumn(col.id, { width });
    });
  };

  return (
    <section className="column-tree-card" aria-label="Table Columns">
      <div className="column-tree-header">
        <div className="column-tree-title-row">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M2.286 1.333h11.428a.952.952 0 0 1 .953.953v11.428a.952.952 0 0 1-.953.953H2.286a.952.952 0 0 1-.953-.953V2.286a.952.952 0 0 1 .953-.953Z"
              stroke="#003366"
              strokeWidth="1.333"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.333 1.333v13.334M10.667 1.333v13.334"
              stroke="#003366"
              strokeWidth="1.333"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <h3 className="column-tree-title">Table Columns</h3>
        </div>
        <p className="column-tree-subtitle">
          Define the reusable column structure first. Column changes update the
          publishing preview instantly.
        </p>
      </div>

      <div className="column-tree-body">
        {schema.columns.length === 0 ? (
          <div className="panel-empty">No columns yet. Click Add Column.</div>
        ) : (
          schema.columns.map((col) => (
            <ColumnTreeNode key={col.id} column={col} level={0} />
          ))
        )}
      </div>

      <div className="column-tree-footer">
        <button
          type="button"
          className="btn btn-sm btn-primary"
          onClick={addRootColumn}
          disabled={isLocked}
        >
          Add Column
        </button>
        <button
          type="button"
          className="btn btn-sm btn-primary"
          onClick={handleAddChild}
          disabled={isLocked || !selectedColumn}
        >
          Add Child Column
        </button>
        <button
          type="button"
          className="btn btn-sm btn-primary"
          onClick={handleEqualDistribution}
          disabled={isLocked}
        >
          Equal Width
        </button>
      </div>
    </section>
  );
}
